import { z } from "zod";

export const ZodPassword = z
	.string()
	.min(8)
	/**
	 * Test for at least one uppercase letter
	 */
	.refine((value) => {
		return /[A-Z]/.test(value);
	}, "Password must contain at least one uppercase letter.")
	/**
	 * Test for at least one lowercase letter
	 */
	.refine((value) => {
		return /[a-z]/.test(value);
	}, "Password must contain at least one lowercase letter.")
	/**
	 * Test for at least one number
	 */
	.refine((value) => {
		return /[0-9]/.test(value);
	}, "Password must contain at least one number.")
	/**
	 * Test for at least one special character
	 */
	.refine((value) => {
		return /[^A-Za-z0-9]/.test(value);
	}, "Password must contain at least one special character.")
	/**
	 * Test for no whitespace
	 */
	.refine((value) => {
		return !/\s/.test(value);
	}, "Password must not contain any whitespace.");
